import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import search1 from "../../../../Components/Admin/assets/icons/search.png";
import Table from "react-bootstrap/Table";
import Header from "../../Header/Header";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../../common/ModalDelete";
import { EditButton } from "../../../common/Button";
import { Select2Data } from "../../../../utils/common";
import { AllTicketStatus } from "../../../../utils/apis/masters/masters";
import Select from "react-select";
import { Permission } from "../../../../utils/permissions";
library.add(fas);

// *****************************************************************************************************

const Tables = () => {
  const { getData, deleteData, ErrorNotify, isAllow, Per_Page_Dropdown, IMG_URL } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [ticket_status_id, setticket_status_id] = useState(null);
  const getDataAll = async () => {
    const response = await getData(
      `/ticket-management/tickets?page=${currentPage}&per_page=${perPage}&term=${search}&ticket_status_id=${ticket_status_id?.value || ""}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    // setticket_status_id(response?.data?.ticket_status_id || null);

    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
    getMastersData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeStatus, perPage, reset, show, show1]);


  // Modal function
  const handleClose = () => setShowAdd(false);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [, setAllChecked] = useState([]);



  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);


  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/ticket-management/tickets/${recordToDeleteId}`,
      );

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //toggle columnns.........

  const [ticket_status, setTicketStatus] = useState([]);

  const getMastersData = async () => {
    const res = await AllTicketStatus();
    await setTicketStatus(await Select2Data(res?.data, "ticket_status_id"));
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Tickets"} link={"/ticket-management/tickets"} />
        <section className="AdvanceDashboard">
          <div className="col-xxl-12 col-xl-12  ">
            <section className="Tabels tab-radio tab-radio mt-3">
              <div className="">
                <div className="row">
                  <div className="d-flex">
                    <div className="add me-3"></div>
                  </div>
                  {/* <div className="border-line mt-3"></div> */}
                  <div className="row mt-4">
                    <div className="  col-lg-4 col-md-4 col-12">
                      <div className="d-flex">
                        <div className="show me-2">
                          <p className="show mt-1">Show</p>
                        </div>
                        <div className="number me-2">
                          <select
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                            onChange={(e) => setperPage(e.target.value)}
                          >
                            {option?.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="entries">
                          <p className="show mt-1">entries</p>
                        </div>
                      </div>
                    </div>
                    <div className="  col-lg-8  col-md-8 col-12">
                      <div className="d-flex justify-content-end">
                        <div className="sowing me-2">
                          <p className="show mt-2">{`Showing ${Math.min(
                            (currentPage - 1) * perPage + 1,
                          )} to ${Math.min(
                            currentPage * perPage,
                            data?.data?.totalEntries,
                          )} of ${data?.data?.totalEntries} entries`}</p>
                        </div>
                        <div className="num me-2">
                          <input
                            aria-label="Search"
                            type="text"
                            className="form-control"
                            id=""
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                          />
                        </div>

                        <div className="num me-2">
                          <Select
                            aria-label="Ticket Status"
                            name="ticket_status_id"
                            placeholder="Ticket Status"
                            options={ticket_status}
                            value={ticket_status_id}
                            onChange={(selectedOption) =>
                              setticket_status_id(selectedOption)
                            }
                          />
                        </div>
                        <div className="Search me-2">
                          <button
                            aria-label="Search"
                            type="button"
                            onClick={getDataAll}
                            className="btn btn-search"
                          >
                            <img src={search1} className="search" alt="" />
                          </button>
                        </div>

                        <div className="Search-1">
                          <button
                            type="button"
                            onClick={() => {
                              setSearch("");
                              setticket_status_id(null);
                              setReset(!reset);
                            }}
                            className="btn btn-reset"
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-line mt-3"></div>
                <div className="row mt-3">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr className="">
                          {<th className="sr">Sr. No.</th>}
                          {<th className="tax-name">Service No </th>}
                          {<th className="tax-name">Tickets No </th>}
                          {<th className="tax-name">Tickets Status </th>}
                          {<th className="tax-name">Subject </th>}
                          {<th className="tax-name">Title </th>}
                          {<th className="tax-name">Description </th>}
                          {<th className="tax-name">Image </th>}
                          {<th className="tax-name">Remarks </th>}
                          {<th className="tax-name">Action By </th>}
                          {/* {isAllow.includes(Permission.Tickets.Action.name) ? (
                            <> {<th className="tax-name">Status</th>} </>
                          ) : (
                            <></>
                          )} */}

                          {isAllow.includes(Permission.Tickets.Action.name) ? (
                            <> {<th className="active">Action</th>} </>
                          ) : (
                            <></>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.data?.map((d, index) => {
                          return (
                            <tr className="" key={index}>
                              {<td>{++index}.</td>}
                              {
                                <td>
                                  {" "}
                                  {/* d?.user?.contact_no +
                                    " " + */}
                                  {d?.user?.f_name ||
                                    null + " " + d?.user?.l_name ||
                                    null}
                                </td>
                              }
                              {<td>{d?.ticket_no}</td>}
                              {<td>{d?.ticket_status?.name}</td>}
                              {<td>{d?.subject?.name}</td>}
                              {<td>{d?.title}</td>}
                              {<td>{d?.description}</td>}
                              {
                                <td>
                                  {d?.image && (
                                    <img
                                      src={IMG_URL + d.image}
                                      width={100}
                                      height={100}
                                      alt="Ticket attachment"
                                    />
                                  )}
                                  {/* {IMG_URL + d?.image} */}
                                </td>
                              }

                              {<td>{d?.remarks}</td>}
                              {
                                <td>
                                  {d?.action_by &&
                                    (d?.action_by?.f_name ||
                                      null + " " + d?.action_by?.l_name ||
                                      null)}
                                </td>
                              }
                              {/* {isAllow.includes(Permission.Tickets.Action.name) ? (
                                <>
                                  {
                                    <td>
                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          checked={d.status}
                                          onChange={() => {
                                            ChangeStatus(d.id);
                                          }}
                                          id={`flexSwitchCheckDefault${d?.id}`}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`flexSwitchCheckDefault${d?.id}`}
                                        >
                                          {d.status ? "Active" : "Inactive"}
                                        </label>
                                      </div>
                                    </td>
                                  }
                                </>
                              ) : (
                                <></>
                              )} */}

                              {isAllow.includes(
                                Permission.Tickets.Action.name,
                              ) ? (
                                <>
                                  {
                                    <td>
                                      <div className="d-flex">
                                        {isAllow.includes(
                                          Permission.Tickets.Action.name,
                                        ) && (
                                          <EditButton
                                            handleShow1={handleShow1}
                                            id={d?.id}
                                          />
                                        )}
                                        {/* {isAllow.includes(
                                          Permission.Tickets.Delete?.name,
                                        ) && (
                                          <DeletButton
                                            showDeleteRecord={showDeleteRecord}
                                            id={d?.id}
                                            name={d?.name}
                                          />
                                        )} */}
                                      </div>
                                    </td>
                                  }
                                </>
                              ) : (
                                <></>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
